var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { IdLoca } from "../../utils/i18n/IdLoca";
import { TypeActionBuildings } from "../player-base/buildings/actionBuildings";
import { TypeActionTooltip } from "./actionTooltip";
var initialBuildingInfo = {
    buildingLevel: -1,
    id: "",
    loca: IdLoca.empty,
    position: new PIXI.Point(-100, -100),
    replacements: new Map(),
    shouldRender: false,
};
var initial = {
    cursor: { x: 0, y: 0 },
    tooltipBuildingVisible: true,
    tooltipTextBuildingInfo: initialBuildingInfo,
    visible: true,
};
var setStateForKey = function (oldState) { return function (key, value) {
    var _a;
    return (__assign({}, oldState, (_a = {}, _a[key] = value, _a)));
}; };
export var reducerTooltip = function (state, action) {
    if (state === void 0) { state = initial; }
    var setTooltipState = setStateForKey(state);
    switch (action.type) {
        case TypeActionTooltip.SetCursor:
            return setTooltipState("cursor", action.cursor);
        case TypeActionTooltip.SetContent:
            return setTooltipState("content", action.content);
        case TypeActionTooltip.ShowBuildingTooltipText:
            return setTooltipState("tooltipTextBuildingInfo", {
                buildingLevel: action.buildingLevel || -1,
                id: action.id,
                loca: action.loca,
                position: action.position,
                replacements: action.replacements || new Map(),
                shouldRender: state.tooltipBuildingVisible,
            });
        case TypeActionTooltip.HideBuildingTooltipText:
            return setTooltipState("tooltipTextBuildingInfo", {
                initial: initial,
            });
        case TypeActionBuildings.Select:
            return __assign({}, state, { tooltipBuildingVisible: false, tooltipTextBuildingInfo: __assign({}, initialBuildingInfo) });
        case TypeActionBuildings.Deselect:
            return setTooltipState("tooltipBuildingVisible", true);
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tooltip/reducerTooltip.ts
// module id = 2980
// module chunks = 3